// src/components/layout/BackgroundVideoUploader.js - Grand Finále background video card.
// Thin wrapper around the shared MediaUploadCard (audit FL-11, FL-39): one progress bar,
// Czech texts, removal confirmed in a dialog instead of window.confirm.
import React from 'react';
import MediaUploadCard from '../leader/MediaUploadCard';

const BackgroundVideoUploader = ({
  choreographyId,
  backgroundVideo,
  onVideoUploaded,
  editable = true,
  lockedReason,
  competitionDate,
}) => (
  <MediaUploadCard
    kind="background"
    choreographyId={choreographyId}
    competitionDate={competitionDate}
    file={backgroundVideo}
    editable={editable}
    lockedReason={lockedReason}
    onUploaded={onVideoUploaded}
    onRemoved={onVideoUploaded}
  />
);

export default BackgroundVideoUploader;
